export default __webpack_public_path__ + "static/media/deleteConfirmation.20b7fc43.png";